import { ReactElement } from 'react'

import Image from 'next/image'

import { Link } from '@/i18n/navigation'

import { generateImagePlaceHolder } from '@/lib/utils'

import styles from './styles.module.scss'

interface Props {
    title: string
    coverImage: string | null
    link: string
    excerpt: string
}

export default function ArticleMinItem({
    title,
    coverImage,
    link,
    excerpt,
}: Props): ReactElement {
    return (
        <Link className={styles.link} href={link}>
            <div className={styles.outer}>
                <Image
                    className={styles.image}
                    width={410}
                    height={150}
                    // todo: Сделать изображение заглушку
                    src={coverImage ?? ''}
                    alt={title}
                    placeholder={generateImagePlaceHolder(410, 150)}
                    quality={100}
                    draggable={false}
                />
            </div>
            <div className={styles.info}>
                <div className={styles.info__title}>{title}</div>
                <div className={styles.info__paragraph}>{excerpt}</div>
                {/*<div className={styles.info__date}>{updatedAt}</div>*/}
            </div>
        </Link>
    )
}
